// removed by extract-text-webpack-plugin
module.exports = {"made":"qempo_PaymentBox_made-3wAFiU7","amount":"qempo_PaymentBox_amount-3kpG0cj","refund":"qempo_PaymentBox_refund-1e01HwE","qempoServices":"qempo_PaymentBox_qempoServices-3FMj-J9","estimatedTaxes":"qempo_PaymentBox_estimatedTaxes-17SH26k"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/payments/components/PaymentsMade/PaymentBox/PaymentBox.scss
// module id = 1810
// module chunks = 0